import { ACTIVITY_TYPES } from '../../constants';
import resolveProblemIcon from '../../assets/icon-resolve-problem.svg';
import logProblemIcon from '../../assets/icon-log-problem.svg';
import visibilityAppIcon from '../../assets/icon-visibility-app.svg';
import manualTrackIcon from '../../assets/icon-manual-track.svg';
import shipperIcon from '../../assets/icon-status-at-shipper.svg';
import consigneeIcon from '../../assets/icon-status-at-consignee.svg';
import bookedIcon from '../../assets/icon-status-booked.svg';
import deliveredIcon from '../../assets/icon-status-delivered.svg';
import dispatchIcon from '../../assets/icon-status-dispatch.svg';
import inTransitIcon from '../../assets/icon-status-in-transit.svg';
import paperworkIcon from '../../assets/icon-status-paperwork.svg';
import visibilityAppConnectionIcon from '../../assets/icon-visibility-app-connection.svg';
import tmsNoteIcon from '../../assets/icon-tms-internal-note.svg';
import bounceIcon from '../../assets/icon-bounce.svg';

/**
 * Maps a status to an icon, and returns the icon's source string.
 * @param {string} status - Gets an activity icon based off status
 * @param {string} - Src string of the corresponding icon.
 * @return {string} - Path to icon src
 */
const getActivityIcon = (status) => {
  switch (status) {
    case ACTIVITY_TYPES.resolveProblem:
      return resolveProblemIcon;
    case ACTIVITY_TYPES.logProblem:
      return logProblemIcon;
    case ACTIVITY_TYPES.visibilityAppTrack:
      return visibilityAppIcon;
    case ACTIVITY_TYPES.manualTrack:
      return manualTrackIcon;
    case ACTIVITY_TYPES.updateStatusAtShipper:
      return shipperIcon;
    case ACTIVITY_TYPES.updateStatusAtConsignee:
      return consigneeIcon;
    case ACTIVITY_TYPES.updateStatusBooked:
      return bookedIcon;
    case ACTIVITY_TYPES.updateStatusPaperwork:
      return paperworkIcon;
    case ACTIVITY_TYPES.updateStatusInTransit:
      return inTransitIcon;
    case ACTIVITY_TYPES.updateStatusDelivered:
      return deliveredIcon;
    case ACTIVITY_TYPES.updateStatusDispatch:
      return dispatchIcon;
    case ACTIVITY_TYPES.visibilityAppStatusUpdate:
      return visibilityAppConnectionIcon;
    case ACTIVITY_TYPES.internalTmsNote:
      return tmsNoteIcon;
    case ACTIVITY_TYPES.internalTmsTrack:
      return tmsNoteIcon;
    case ACTIVITY_TYPES.bounce:
      return bounceIcon;
    default:
      return manualTrackIcon;
  }
};

export default getActivityIcon;
